import React from 'react';
import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../store/ThemeContext';
import Tooltip from './ui/Tooltip';
import styles from './ThemeToggle.module.css';

const ThemeToggle = () => {
    const { theme, toggleTheme } = useTheme();

    return (
        <Tooltip title={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`} placement="bottom">
        <button
            className={styles.themeToggle}
            onClick={toggleTheme}
            aria-label={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
        >
            {theme === 'light' ? (
                <Moon size={20} strokeWidth={2} />
            ) : (
                <Sun size={20} strokeWidth={2} />
            )}
        </button>
        </Tooltip>
    );
};

export default ThemeToggle;
